// @ts-nocheck 424ce16c
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['address_input_design_discovermore_label'],
      sections: [addPanel.sections.getSections().developer.addressInputSection],
    };
  },
};
